import { render, staticRenderFns } from "./WorkElem.vue?vue&type=template&id=396c2a70&scoped=true&"
import script from "./WorkElem.vue?vue&type=script&lang=js&"
export * from "./WorkElem.vue?vue&type=script&lang=js&"
import style0 from "./WorkElem.vue?vue&type=style&index=0&id=396c2a70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396c2a70",
  null
  
)

export default component.exports